import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { createNewFilter, createNewGroup, addFilterToMap, addFilterToMainItem, findItemFilterById, addFilterToItem, removeFilterItem, addGroupFilterToItem, addGroupToMap, unGroupFilterToItem, changeGroupOperator, changeFilterItem } from './actions.js';
import QueryBuilderFormat from '../format/format.js';
import './types.js';
import '../format/sqlFormat.js';
import '../format/xmlFormat.js';
import '../format/sqlSafeFormat.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Fluent interface: https://en.wikipedia.org/wiki/Fluent_interface
 *
 * @param idGroup
 * @param parentIdGroup
 * @param items
 * @param idFilter
 * @param value
 * @param data
 * @class QueryBuilderStore
 */

var QueryBuilderStore = /*#__PURE__*/function () {
  function QueryBuilderStore(init, _format) {
    var _this = this;

    _classCallCheck(this, QueryBuilderStore);

    _defineProperty(this, "items", []);

    _defineProperty(this, "step", 0);

    _defineProperty(this, "steps", {});

    _defineProperty(this, "mapFilters", {});

    _defineProperty(this, "mapGroups", {});

    _defineProperty(this, "main", null);

    _defineProperty(this, "format", null);

    _defineProperty(this, "createNewFilter", function (idGroup) {
      return createNewFilter.call(_this, idGroup);
    });

    _defineProperty(this, "createNewGroup", function (parentIdGroup) {
      return createNewGroup.call(_this, parentIdGroup);
    });

    _defineProperty(this, "onOrderDragAndDrop", function (items) {
      _this.items = items;
      return _this.getState();
    });

    _defineProperty(this, "addFilterNextToFilterId", function (idGroup, idFilter) {
      // eslint-disable-line
      _this.addFilter(idGroup);

      return _this.getState();
    });

    _defineProperty(this, "addFilter", function (idGroup) {
      var newFilter = _this.createNewFilter(idGroup);

      addFilterToMap.call(_this, newFilter); // new API

      if (_this.main === idGroup) {
        addFilterToMainItem.call(_this, _this.items, newFilter);
      } else {
        var foundInItems = findItemFilterById.call(_this, idGroup);

        if (foundInItems) {
          addFilterToItem.call(_this, foundInItems, newFilter);
        }
      }

      return _this.getState();
    });

    _defineProperty(this, "onRemoveFilter", function (idFilter) {
      // new API
      removeFilterItem.call(_this, idFilter);
      return _this.getState();
    });

    _defineProperty(this, "addRuleContainerInPlace", function (idGroup, idFilter) {
      // Create a new group
      var newGroup = _this.createNewGroup(idGroup);

      addGroupFilterToItem.call(_this, idGroup, idFilter, newGroup);
      return _this.getState();
    });

    _defineProperty(this, "addRuleContainer", function (idGroup, idFilter) {
      // eslint-disable-line
      var newGroup = _this.createNewGroup(idGroup);

      addGroupToMap.call(_this, newGroup);

      if (_this.main === idGroup) {
        addFilterToMainItem.call(_this, _this.items, newGroup);
      } else {
        var foundInItems = findItemFilterById.call(_this, idGroup);

        if (foundInItems) {
          addFilterToItem.call(_this, foundInItems, newGroup);
        }
      }

      return _this.getState();
    });

    _defineProperty(this, "unGroup", function (idGroup) {
      unGroupFilterToItem.call(_this, idGroup);
      return _this.getState();
    });

    _defineProperty(this, "changeGroupOperator", function (idGroup, value) {
      _this.getGroupById(idGroup).condition = value;
      changeGroupOperator.call(_this, idGroup, value);
      return _this.getState();
    });

    _defineProperty(this, "changeFilter", function (data) {
      var idFilter = data.idFilter;
      _this.mapFilters[idFilter] = _objectSpread(_objectSpread({}, _this.mapFilters[idFilter]), data);
      changeFilterItem.call(_this, data);
      return _this.getState();
    });

    _defineProperty(this, "getGroupById", function (idGroup) {
      return _this.mapGroups[idGroup] || {};
    });

    _defineProperty(this, "getFilterById", function (idFilter) {
      return _this.mapFilters[idFilter];
    });

    _defineProperty(this, "getInitialState", function () {
      var newFilters = {
        step: _this.step,
        mapFilters: _objectSpread({}, _this.mapFilters),
        mapGroups: _objectSpread({}, _this.mapGroups),
        main: _this.main,
        items: _this.items
      };
      var format = QueryBuilderFormat.run(newFilters, _this.format);
      return _objectSpread(_objectSpread({}, newFilters), {}, {
        format: format
      });
    });

    _defineProperty(this, "getState", function () {
      _this.step += 1;
      var newFilters = {
        step: _this.step,
        mapFilters: _objectSpread({}, _this.mapFilters),
        mapGroups: _objectSpread({}, _this.mapGroups),
        main: _this.main,
        items: _this.items
      };
      var format = QueryBuilderFormat.run(newFilters, _this.format);
      return _objectSpread(_objectSpread({}, newFilters), {}, {
        format: format
      });
    });

    this.firstLoad = true;
    this.format = _format;
    if (init) return this.initSetupUp(init);
    var mainGroup = this.createNewGroup('main');
    this.mapGroups = _defineProperty({}, mainGroup.idGroup, mainGroup);
    this.main = mainGroup.idGroup;
    this.addFilter(mainGroup.idGroup);
  }

  _createClass(QueryBuilderStore, [{
    key: "initSetupUp",
    value: function initSetupUp(init) {
      var _this2 = this;

      this.step = init.step || 1;
      Object.keys(init).forEach(function (key) {
        if (init[key] && _this2[key] !== undefined) _this2[key] = init[key];
      });
    }
  }]);

  return QueryBuilderStore;
}();

export default QueryBuilderStore;
//# sourceMappingURL=store.js.map
